import React, { useEffect,useState } from 'react';
import { getCategories } from 'actions';
import { capitalizeWords, randomString } from 'helpers/string';
import AuctionsSearchPage from 'components/Auctions/AuctionSearchPage';
import { connect } from 'react-redux';
import AuctionsCityList from 'components/Auctions/AuctionSearchPage/AuctionsByState';
import { useRouter } from 'next/router';
import CityTopContentBlock from 'components/Auctions/AuctionSearchPage/CityTopContentBlock';
import { formatCityState } from 'components/Auctions/AuctionSearchPage/utils';
import { usePage } from 'context/PageContext';

const CitySearch = props => {
    const router = useRouter();
    const location = formatCityState(`${capitalizeWords(router?.query?.city)}, ${router.query.state}`);
    const [loadingCity, setLoadingCity] = useState(true);
    const { setPage, resetPage } = usePage();

    useEffect(() => {
        setPage({
            title: `Storage Auctions in ${location}`,
            h1: `Storage Auctions in ${location}`,
            marginBottom: 'pageTitle marginB20',
            description: undefined,
        });

        return () => {
            resetPage();
        };
    }, [router.query]);

    return (
        <AuctionsSearchPage
            {...props}
            locationUpdate={location}
            loadingCity={loadingCity}
        >
            <CityTopContentBlock loc={location} />
            <AuctionsCityList
                state={router?.query?.state}
                title={`Auctions by City in ${router?.query?.state.toUpperCase()}`}
                setLoadingCity={setLoadingCity}
            />
        </AuctionsSearchPage>
    );
};

CitySearch.getInitialProps = async ({store: { dispatch }, query}, { auction: { categories } })  => {
    await Promise.all([
        new Promise(async (resolve) => {
            !categories.length && await dispatch(getCategories());

            resolve();
        }),
    ]);

    const rand_str = randomString();
    const pageData = { 
        title: `Storage Auctions in ${query.city}, ${query.state}`, 
        marginBottom: 'pageTitle marginB20',
        h1: `Storage Auctions in ${query.city}, ${query.state}`,
        description: undefined,
    };

    return { query, rand_str, pageData };
};


export default connect(({address}) => ({address}), {})(CitySearch);